import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { UserSubtitle } from '../../commons/UserSubtitle';
import { CustomSkeletonElement } from '../../commons/CustomSkeletonElement';
import { IMultiAccount } from '../../../models/UserInfo';

interface PaymentTitleProps {
  address: string;
  isSuspension?: boolean;
  account: IMultiAccount | null;
}

const PaymentTitle: FC<PaymentTitleProps> = ({ address, account, isSuspension }) => {
  const { t } = useTranslation();
  const adminTitle = isSuspension ? t('servicePayment.suspensionOfService') : t('servicePayment.serviceActivation');
  const childTitle = isSuspension
    ? t('servicePayment.suspensionAccountActivation')
    : t('servicePayment.serviceAccountActivation');

  if (!account) {
    return (
      <h1 className="payment__title">
        {typeof isSuspension === 'undefined' ? (
          <CustomSkeletonElement
            skeletonContainerClassName="payment-title-skeleton"
            skeletonChildrenClassName="payment-title-skeleton__btn skeleton"
            childrenCount={1}
          />
        ) : (
          adminTitle
        )}
      </h1>
    );
  }
  return (
    <h1 className="payment__title">
      {typeof isSuspension === 'undefined' ? (
        <CustomSkeletonElement
          skeletonContainerClassName="payment-title-skeleton"
          skeletonChildrenClassName="payment-title-skeleton__btn skeleton"
          childrenCount={1}
        />
      ) : (
        childTitle
      )}
      <UserSubtitle address={address.trim()} userId={account.UserID} />
    </h1>
  );
};

export default PaymentTitle;
